import _ from 'lodash';

import { IColorControlServerMode } from './color-control-server-mode.interface';
import { ColorUtils } from '../color.utils';

export class ColorControlServerXYMode implements IColorControlServerMode {
  public statusPayload = ['CurrentX', 'CurrentY'];
  public setColorMethod = 'MoveToColor';

  public computateColor = (state: any) => {
    const currentX: number = <number> _.get(state, 'currentX');
    const currentY: number = <number> _.get(state, 'currentY');
    if (currentX != null && currentY != null) {
      const x = currentX / 65536;
      const y = currentY / 65536;
      return ColorUtils.xyYtoRGB(x, 100, y);
    }
    return null;
  };

  public computateColorName = (state: any) => {
    const rgb = this.computateColor(state);
    if (rgb) {
      return ColorUtils.RGBtoColorName(rgb).en;
    }
    return '';
  };

  public buildPayload = (rgb: any) => {
    const { x, y1 } = ColorUtils.RGBtoxyY(rgb.r, rgb.g, rgb.b);
    return {
      ColorX: x * 65536,
      ColorY: y1 * 65536,
      TransitionTime: 50
    };
  };

  public getEffectColor = (params: any) => {
    return this.computateColor({
      currentX: params.ColorX,
      currentY: params.ColorY
    });
  };

  public getEffectColorName = (params: any) => {
    return this.computateColorName({
        currentX: params.ColorX,
        currentY: params.ColorY
    });
  };
}
